import Table from "../../../../components/UI/Table/Table"
import HistoryComponent from "./component/HistoryComponent"
import styles from "./History.module.css"
function History({ props }) {
    
    return (


        <div className={styles.model_box}>
            <Table head={<tr>
                <th>ID аукциона</th>
                <th>Сумма</th>
                <th>Статус</th>
                <th>Процент от ставок</th>
                
                <th>Прибыль</th>
                <th>Дата</th>


                

            </tr>} body={props.history_auction.map((data) => (
                <HistoryComponent data={data} />
            ))} />

        </div>
    )
}
export default History